export default __webpack_public_path__ + "static/media/bg.26843946.jpg";